module.exports = __webpack_public_path__ + "img/dashboard-tooltip.bad62a7b.svg";